import React from 'react';
import { Calendar, AlertCircle, CheckCircle, ArrowUpRight } from 'lucide-react';

const BookingStats = ({ stats }) => {
  const statConfigs = [
    { label: 'Total Orders', value: stats.total || 0, icon: Calendar, color: 'teal' },
    { label: 'Pending Approval', value: stats.pending || 0, icon: AlertCircle, color: 'amber' },
    { label: 'Active Orders', value: stats.active || 0, icon: CheckCircle, color: 'emerald' },
    { label: 'Completed', value: stats.completed || 0, icon: ArrowUpRight, color: 'indigo' }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4">
      {statConfigs.map((stat, idx) => {
        const Icon = stat.icon;
        return (
          <div
            key={idx}
            className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between group"
          >
            <div className="flex justify-between items-start mb-2">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-wider">
                {stat.label}
              </span>
              <div className={`w-8 h-8 rounded-xl flex items-center justify-center ${
                stat.color === 'teal' ? 'bg-teal-50 text-[#067978]' :
                stat.color === 'amber' ? 'bg-amber-50 text-amber-600' :
                stat.color === 'emerald' ? 'bg-emerald-50 text-emerald-600' :
                'bg-indigo-50 text-indigo-600'
              }`}>
                <Icon size={16} />
              </div>
            </div>

            <div>
              <p className="text-xl sm:text-2xl font-black text-slate-800 leading-none">
                {stat.value.toLocaleString()}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BookingStats;
